import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["columns", "data", "rowSelection", "sortModel", "onSortChange"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Table/Table.js",
  _this = this;
import React, { useCallback } from 'react';
import Text from '../Text';
import Checkbox from '../Checkbox';
import Radio from '../Radio';
import useSelect from './hooks/useSelect';
import useSorting from './hooks/useSorting';
import SortingUp from '@dls/assets/icons/SortingUp';
import SortingDown from '@dls/assets/icons/SortingDown';
import SortingNeutral from '@dls/assets/icons/SortingNeutral';
import * as SC from './style';
var sortingIcons = {
  asc: /*#__PURE__*/React.createElement(SortingUp, {
    "data-testid": "table-asc-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 8
    }
  }),
  desc: /*#__PURE__*/React.createElement(SortingDown, {
    "data-testid": "table-desc-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }),
  "null": /*#__PURE__*/React.createElement(SortingNeutral, {
    "data-testid": "table-neutral-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  })
};
var Table = function Table(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    rowSelection = _ref.rowSelection,
    sortModel = _ref.sortModel,
    onSortChange = _ref.onSortChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSelect = useSelect({
      data: data,
      rowSelection: rowSelection
    }),
    onSelect = _useSelect.onSelect,
    onSelectAll = _useSelect.onSelectAll,
    getRecordIndex = _useSelect.getRecordIndex,
    isAllSelected = _useSelect.isAllSelected;
  var _useSorting = useSorting({
      sortModel: sortModel,
      onSortChange: onSortChange,
      columns: columns
    }),
    onSortClick = _useSorting.onSortClick,
    sortingModels = _useSorting.sortingModels;
  var renderColumn = function renderColumn(column, record, index) {
    if (column.render && typeof column.render === 'function') {
      return column.render({
        value: record[column.key],
        record: record,
        index: index
      });
    } else {
      return record[column.key];
    }
  };
  var renderSortingIcon = useCallback(function (columnKey) {
    var _sortingModels$column;
    var sort = ((_sortingModels$column = sortingModels[columnKey]) === null || _sortingModels$column === void 0 ? void 0 : _sortingModels$column.sort) || null;
    return sortingIcons[sort];
  }, [sortingModels]);
  return /*#__PURE__*/React.createElement(SC.TableContainer, {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SC.Table, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("thead", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SC.tr, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 11
    }
  }, (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'checkbox' ? /*#__PURE__*/React.createElement(SC.Headth, {
    width: rowSelection.width,
    styles: rowSelection.style,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Checkbox.Input, {
    checked: isAllSelected,
    onChange: onSelectAll,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 17
    }
  })) : (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'radio' ? /*#__PURE__*/React.createElement(SC.Headth, {
    width: rowSelection.width,
    styles: rowSelection.style,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 15
    }
  }) : null, columns.map(function (item) {
    return /*#__PURE__*/React.createElement(SC.Headth, {
      key: 'th-' + item.key,
      alignment: item.alignment,
      width: item.width,
      styles: item.style,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(SC.HeadContent, {
      "data-testid": "table-sortBtn",
      sortable: item.sortable,
      onClick: function onClick() {
        return onSortClick(item);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Text, {
      type: "header",
      tag: "span",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 19
      }
    }, item.title), item.sortable ? /*#__PURE__*/React.createElement(SC.SortWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(SC.HeadSorter, {
      enableInteraction: item.sortable,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 23
      }
    }, renderSortingIcon(item.key))) : null));
  }))), /*#__PURE__*/React.createElement("tbody", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 9
    }
  }, data.map(function (record, index) {
    return /*#__PURE__*/React.createElement(SC.tr, {
      key: 'tr-' + index,
      className: getRecordIndex(record) > -1 ? 'active' : undefined,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 13
      }
    }, (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'checkbox' ? /*#__PURE__*/React.createElement(SC.td, {
      width: rowSelection.width,
      styles: rowSelection.style,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Checkbox.Input, {
      checked: getRecordIndex(record) > -1,
      onChange: function onChange(e, checked) {
        return onSelect(e, checked, record);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 19
      }
    })) : (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'radio' ? /*#__PURE__*/React.createElement(SC.td, {
      width: rowSelection.width,
      styles: rowSelection.style,
      className: (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'radio' ? 'radio' : undefined,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 113,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Radio.Input, {
      checked: getRecordIndex(record) > -1,
      onChange: function onChange(e, checked) {
        return onSelect(e, checked, record);
      },
      "data-testid": "radioInputId",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 19
      }
    })) : null, columns.map(function (item) {
      return /*#__PURE__*/React.createElement(SC.td, {
        key: 'td-' + item.key,
        alignment: item.alignment,
        width: item.width,
        styles: item.style,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Text, {
        type: "body",
        tag: "span",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134,
          columnNumber: 19
        }
      }, renderColumn(item, record, index)));
    }));
  }))));
};
Table.defaultProps = {
  columns: [],
  data: [],
  sortModel: [],
  onSortChange: function onSortChange() {}
};
export default Table;